import { Button } from '@mui/material';

const VisibilityPage = () => {
  return (
    <div style={{ textAlign: 'left', width: '80%' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={{ fontSize: '20px' }}>Visibility Wall (Planned Feature)</h2>

        <p style={{ color: 'gray', fontSize: '12px', lineHeight: '1.1' }}>
          Your work remains protected
          <ul style={{ margin: 0 }}>
            <li>Research is private by default</li>
            <li>You decide what becomes visible</li>
            <li>
              Inquiries are mediated through TSP, <br></br>so your email remains protected
            </li>
          </ul>
        </p>
      </div>

      <div style={{ fontSize: '14px', lineHeight: 1.4, marginBottom: '16px' }}>
        <p style={{ margin: '0 0 10px 0' }}>
          TSP is designed to help researchers compile and organize their work, integrate their tools
          and personal networks, collaborate with others and stay ready to share their work.
        </p>
        <p style={{ margin: '0 0 10px 0' }}>
          TSP is developing a future capability: The Visibility Wall — a way to make your research
          and interests discoverable on your terms, without turning scholarship into social media.
        </p>
        <span
          style={{
            display: 'inline-block',
            fontSize: '16px',
            fontWeight: 600,
            fontStyle: 'normal',
            color: '#202123',
            margin: '4px 0 8px 0',
          }}
        >
          Visibility - On Your Terms
        </span>
        <p style={{ margin: '0 0 8px 0' }}>With visibility, researchers on TSP will be able to:</p>
        <ul style={{ marginTop: '8px', marginBottom: '8px' }}>
          <li>Make research verticals discoverable</li>
          <li>Allow collaboration or inquiry requests through TSP</li>
          <li>
            Share selected publications, resources, or research themes either directly with others
            or more broadly via selected existing tools (such as LinkedIn)
          </li>
          <li>Control exactly what is visible and what remains private</li>
        </ul>
        <p style={{ margin: '8px 0 10px 0' }}>
          All research in TSP is private by default. Nothing becomes visible unless you choose to
          make it visible.
        </p>
        <span
          style={{
            display: 'inline-block',
            fontSize: '16px',
            fontWeight: 600,
            fontStyle: 'normal',
            color: '#202123',
            margin: '4px 0 8px 0',
          }}
        >
          Designed Differently
        </span>
        <p style={{ margin: '0 0 8px 0' }}>
          The Visibility Wall will be built around academic norms. The Visibility Wall will not be a
          social media site. There will be:
        </p>
        <ul style={{ marginTop: '8px', marginBottom: '8px' }}>
          <li>No follower counts</li>
          <li>No engagement metrics</li>
          <li>No algorithmic ranking of researchers</li>
          <li>No forced public posting</li>
        </ul>
        <p style={{ margin: '8px 0 10px 0' }}>
          Visibility is intended to support discovery, connection, and collaboration.
        </p>
        <span
          style={{
            display: 'inline-block',
            fontSize: '16px',
            fontWeight: 600,
            fontStyle: 'normal',
            color: '#202123',
            margin: '4px 0 8px 0',
          }}
        >
          Status
        </span>
        <p style={{ margin: 0 }}>
          The Visibility Wall is currently under development and will be introduced in a future TSP
          release.
        </p>
      </div>

      <Button
        variant="contained"
        sx={{ marginRight: '8px', textTransform: 'none' }}
        onClick={() => window.open('https://www.simple-platform.com/newsletter-signup', '_blank')}
      >
        Notify Me When Available
      </Button>

      <Button
        variant="contained"
        sx={{ textTransform: 'none' }}
        onClick={() => window.open('https://www.simple-platform.com/support', '_blank')}
      >
        Share An Idea
      </Button>

      <p style={{ fontSize: '12px' }}>
        Researchers often have the best ideas about how visibility should work. We welcome
        suggestions.
      </p>
    </div>
  );
};
export default VisibilityPage;
